import { render } from "./Profile.vue?vue&type=template&id=88dae056&scoped=true"
import script from "./Profile.ts?vue&type=script&lang=js&external"
export * from "./Profile.ts?vue&type=script&lang=js&external"

import "../../components/Form/FormBase.scss?vue&type=style&index=0&lang=scss&external"
import "./Profile.scss?vue&type=style&index=1&id=88dae056&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88dae056"]])

export default __exports__